import React from 'react';

interface PropertyMatrixWordmarkProps {
  className?: string;
}

const PropertyMatrixWordmark = ({ className }: PropertyMatrixWordmarkProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="160"
    height="29"
    viewBox="0 0 160 29"
    fill="none"
    className={className}
    aria-label="Property Matrix"
    role="img"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5665 3.94345L28.7983 0V25.7682L7.82545e-05 25.7681V24.1464L11.2829 22.6317V22.6215L11.3332 22.625L11.3604 22.6213V22.6269L26.9701 23.7144V22.2931L11.3337 20.4393L7.35421e-05 23.0394V21.4674L11.2829 17.3149V17.2865L11.334 17.2961L11.3604 17.2864V17.3011L26.9701 20.2392V18.818L11.3341 15.1104L0 20.3692V18.7731L11.2829 11.9979V11.9515L11.3341 11.9672L11.3604 11.9514V11.9753L26.9701 16.7642V15.3396L11.3341 9.75033L8.3432e-05 17.6575L3.50343e-05 16.0585L11.2829 6.64979V6.58528L11.3341 6.60713L11.3605 6.58514V6.61839L22.5665 11.4049V3.94345ZM32.4805 25.7682H30.6395V1.70091L32.4805 3.42076V25.7682ZM33.9524 25.7682V4.79583L35.4243 6.17083V25.7682H33.9524Z"
      fill="#2B67FF"
    />
    <path
      d="M48.7584 14.0674H43.8003V25.764H45.9388V21.6735H48.7584C51.3562 21.6735 52.7502 20.1292 52.7502 17.8786C52.7502 15.6116 51.3562 14.0674 48.7584 14.0674ZM48.6633 19.7678H45.9388V15.973H48.6633C49.9147 15.973 50.5959 16.663 50.5959 17.8786C50.5959 19.0943 49.9147 19.7678 48.6633 19.7678Z"
      fill="#1E232F"
    />
    <path
      d="M58.2557 17.1558C56.9884 17.1558 56.2122 17.8458 55.8162 18.7986V17.2872H53.8837V25.764H55.8796V21.4599C55.8796 19.85 56.7666 19.0943 58.2398 19.0943H58.7467V17.1887C58.5725 17.1558 58.4299 17.1558 58.2557 17.1558Z"
      fill="#1E232F"
    />
    <path
      d="M63.2543 25.9611C65.7413 25.9611 67.4046 24.2198 67.4046 21.5256C67.4046 18.8315 65.7413 17.0901 63.2543 17.0901C60.7674 17.0901 59.0883 18.8315 59.0883 21.5256C59.0883 24.2198 60.7674 25.9611 63.2543 25.9611ZM63.2543 24.2526C61.9554 24.2526 61.1317 23.3162 61.1317 21.5256C61.1317 19.735 61.9554 18.7986 63.2543 18.7986C64.5374 18.7986 65.377 19.735 65.377 21.5256C65.377 23.3162 64.5374 24.2526 63.2543 24.2526Z"
      fill="#1E232F"
    />
    <path
      d="M73.1872 17.0901C71.9992 17.0901 71.128 17.6158 70.5735 18.5029V17.2872H68.6568V28.9838H70.6527V24.6633C71.2072 25.4847 72.0467 25.9611 73.1872 25.9611C75.4366 25.9611 76.8464 24.2198 76.8464 21.5256C76.8464 18.8315 75.4366 17.0901 73.1872 17.0901ZM72.712 24.2526C71.4131 24.2526 70.6052 23.3162 70.6052 21.5256C70.6052 19.735 71.4131 18.7986 72.712 18.7986C74.0109 18.7986 74.8188 19.6693 74.8188 21.4599C74.8188 23.2505 74.0109 24.2526 72.712 24.2526Z"
      fill="#1E232F"
    />
    <path
      d="M85.8074 21.6735C85.8074 18.9793 84.2709 17.0901 81.7681 17.0901C79.3445 17.0901 77.7288 18.8643 77.7288 21.5256C77.7288 24.2362 79.392 25.9611 81.7998 25.9611C83.764 25.9611 85.1897 24.8605 85.6015 23.1355H83.6848C83.3838 23.8912 82.7661 24.3512 81.8156 24.3512C80.6593 24.3512 79.8356 23.6777 79.693 22.1663H85.8074V21.6735ZM81.7523 18.7C82.9403 18.7 83.6531 19.5214 83.8115 20.7207H79.7088C79.8989 19.3243 80.6909 18.7 81.7523 18.7Z"
      fill="#1E232F"
    />
    <path
      d="M91.4682 17.1558C90.201 17.1558 89.4248 17.8458 89.0288 18.7986V17.2872H87.0962V25.764H89.0921V21.4599C89.0921 19.85 89.9792 19.0943 91.4524 19.0943H91.9593V17.1887C91.785 17.1558 91.6425 17.1558 91.4682 17.1558Z"
      fill="#1E232F"
    />
    <path
      d="M97.3749 18.8643V17.2872H95.7591V14.8231H93.7791V17.2872H92.5118V18.8643H93.7791V23.6612C93.7791 25.2219 94.6028 25.8297 96.3294 25.8297C96.6462 25.8297 97.0105 25.7968 97.3749 25.764V24.1869H96.6937C96.0284 24.1869 95.7591 24.0062 95.7591 23.4477V18.8643H97.3749Z"
      fill="#1E232F"
    />
    <path
      d="M103.882 17.2872L103.216 19.4229C102.773 20.9178 102.329 22.462 101.902 24.1376C101.49 22.4784 101.046 20.8849 100.603 19.4064L99.9375 17.2872H97.7831L100.159 24.2526C100.349 24.8112 100.539 25.4519 100.539 25.9611C100.539 26.6675 100.175 27.3246 99.193 27.3246H98.4326V28.951C98.6861 28.9838 98.9237 29.0003 99.3038 29.0003C101.284 29.0003 102.171 28.3432 102.82 26.454L105.973 17.2872H103.882Z"
      fill="#1E232F"
    />
    <path
      d="M119.252 14.0674L117.367 19.6364C117.018 20.6878 116.654 21.9035 116.369 22.922C116.083 21.9527 115.735 20.8028 115.402 19.7514L113.454 14.0674H110.349V25.764H112.408V22.1992C112.408 20.4414 112.393 18.5358 112.345 16.433C112.599 17.3037 112.852 18.0922 113.185 19.0943L115.481 25.764H117.24L119.521 19.0943C119.869 18.0758 120.123 17.2872 120.376 16.4001C120.329 18.5193 120.313 20.425 120.313 22.1992V25.764H122.356V14.0674H119.252Z"
      fill="#1E232F"
    />
    <path
      d="M131.34 25.764C131.119 25.4354 131.008 24.7619 131.008 24.1541V19.6364C131.008 18.1086 130.042 17.0901 127.602 17.0901C125.052 17.0901 124.038 18.1908 123.927 19.9814H125.891C125.971 18.9464 126.446 18.6343 127.586 18.6343C128.743 18.6343 129.075 19.0286 129.075 19.6857C129.075 20.31 128.679 20.5564 127.919 20.6549L126.683 20.7699C124.371 20.9999 123.547 22.002 123.547 23.4148C123.547 25.0576 124.751 25.9611 126.493 25.9611C127.697 25.9611 128.584 25.5176 129.123 24.729C129.154 25.1397 129.218 25.534 129.345 25.764H131.34ZM126.968 24.4826C126.05 24.4826 125.59 24.0391 125.59 23.3327C125.59 22.6591 125.955 22.2484 127.064 22.117L128.141 21.9856C128.568 21.9363 128.869 21.8377 129.075 21.6406V22.4127C129.075 23.8912 128.03 24.4826 126.968 24.4826Z"
      fill="#1E232F"
    />
    <path
      d="M136.543 18.8643V17.2872H134.927V14.8231H132.947V17.2872H131.68V18.8643H132.947V23.6612C132.947 25.2219 133.771 25.8297 135.498 25.8297C135.814 25.8297 136.179 25.7968 136.543 25.764V24.1869H135.862C135.197 24.1869 134.927 24.0062 134.927 23.4477V18.8643H136.543Z"
      fill="#1E232F"
    />
    <path
      d="M142.084 17.1558C140.816 17.1558 140.04 17.8458 139.644 18.7986V17.2872H137.712V25.764H139.708V21.4599C139.708 19.85 140.595 19.0943 142.068 19.0943H142.575V17.1887C142.401 17.1558 142.258 17.1558 142.084 17.1558Z"
      fill="#1E232F"
    />
    <path
      d="M143.668 16.1866H145.632V14.2481H143.668V16.1866ZM143.652 25.764H145.648V17.2872H143.652V25.764Z"
      fill="#1E232F"
    />
    <path
      d="M151.631 21.4106L154.514 17.2872H152.281L151.853 17.9115C151.425 18.5686 150.966 19.2586 150.554 19.9157C150.126 19.2421 149.699 18.585 149.239 17.9115L148.812 17.2872H146.531L149.414 21.427L146.372 25.764H148.606L148.907 25.3204C149.445 24.5319 149.984 23.7105 150.507 22.922C151.029 23.7105 151.552 24.5155 152.091 25.3204L152.392 25.764H154.673L151.631 21.4106Z"
      fill="#1E232F"
    />
    <path
      d="M156.31 13.9131V14.2874H156.822V15.7982H157.214V14.2874H157.725V13.9131H156.31Z"
      fill="#1E232F"
    />
    <path
      d="M158.987 15.2165L158.486 13.9131H157.969V15.7982H158.343V14.5029L158.842 15.7982H159.117L159.615 14.4948V15.7982H160V13.9131H159.491L158.987 15.2165Z"
      fill="#1E232F"
    />
  </svg>
);

export default PropertyMatrixWordmark;
